
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate",
      function () {
        return require("private-next-pages/corporate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate"])
      });
    }
  